import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimumbaiToMahabaleshwarCab() {



    const cardData = {





keyword: "Navi Mumbai to Mahabaleshwar Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Navi Mumbai to Mahabaleshwar Cab Service for family vacations, honeymoon trips, weekend getaways, corporate travel, sightseeing tours, one-way taxi booking, and round-trip journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a smooth and enjoyable journey from Navi Mumbai to Mahabaleshwar. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, we ensure a safe and hassle-free travel experience. Whether you are planning a relaxing holiday, family outing, group tour, or business trip, Shreesha Tours & Travels delivers dependable Navi Mumbai to Mahabaleshwar cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is one of Mahabaleshwar's most popular attractions, offering boating, horse riding, local food stalls, and beautiful natural surroundings for families and couples."
  },
  {
    title: "Arthur's Seat",
    description: "Arthur's Seat is a famous viewpoint offering breathtaking views of deep valleys, the Savitri River, and the surrounding Sahyadri mountain ranges."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a favorite tourist attraction known for fresh strawberries, delicious food, chocolate products, fruit-based treats, and a relaxing family-friendly atmosphere."
  },
  {
    title: "Elephant's Head Point",
    description: "Elephant's Head Point is a spectacular viewpoint famous for its naturally formed rock structure resembling an elephant's head and panoramic valley views."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point is the highest point in Mahabaleshwar and is well known for magnificent sunrise views and peaceful natural surroundings."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a scenic attraction surrounded by lush greenery, making it one of the best places to visit during the monsoon season."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic Maratha fort famous for the battle of Pratapgad, magnificent architecture, and panoramic mountain views."
  },
  {
    title: "Kate's Point",
    description: "Kate's Point offers spectacular views of the Krishna Valley, Dhom Dam, and surrounding hills, making it a favorite destination for photographers."
  },
  {
    title: "Mahabaleshwar Strawberry Farms",
    description: "Mahabaleshwar is renowned for its strawberry farms where visitors can enjoy fresh strawberries, farm visits, and local fruit products."
  },
  {
    title: "Panchgani",
    description: "Located close to Mahabaleshwar, Panchgani is famous for Table Land, Sydney Point, Parsi Point, and beautiful valley views, making it a perfect addition to your trip."
  }
],


"services": [
  {
    "name": "Mumbai to Mahabaleshwar Cab",
    "description": "Book Mumbai to Mahabaleshwar Cab for safe, comfortable, and affordable hill station travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury cabs for one-way, round-trip, family vacations, and weekend getaways."
  },
  {
    "name": "Mumbai to Mahabaleshwar Taxi Fare",
    "description": "Get affordable Mumbai to Mahabaleshwar Taxi Fare with transparent pricing, no hidden charges, and comfortable chauffeur-driven vehicles for a pleasant journey."
  },
  {
    "name": "Mumbai to Mahabaleshwar Taxi",
    "description": "Choose Mumbai to Mahabaleshwar Taxi for reliable hill station travel with professional drivers, clean AC vehicles, and convenient pickup and drop services."
  },
  {
    "name": "Car from Mumbai to Mahabaleshwar",
    "description": "Hire a Car from Mumbai to Mahabaleshwar for comfortable travel with spacious vehicles, experienced chauffeurs, and flexible travel schedules for families, couples, and groups."
  },
  {
    "name": "Mumbai to Mahabaleshwar Cab Booking",
    "description": "Book Mumbai to Mahabaleshwar Cab Booking online with instant confirmation, multiple vehicle options, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Mumbai to Mahabaleshwar Round Trip Cab",
    "description": "Reserve Mumbai to Mahabaleshwar Round Trip Cab for sightseeing, weekend vacations, and family holidays with flexible return schedules and professional chauffeurs."
  },
  {
    "name": "Taxi for Mahabaleshwar from Mumbai",
    "description": "Book Taxi for Mahabaleshwar from Mumbai for comfortable long-distance travel with premium AC vehicles, verified drivers, and affordable fares."
  },
  {
    "name": "Navi Mumbai to Mahabaleshwar Cab",
    "description": "Reserve Navi Mumbai to Mahabaleshwar Cab for direct pickup, comfortable travel, and reliable chauffeur-driven transportation with multiple cab options."
  },
  {
    "name": "Navi Mumbai to Mahabaleshwar Taxi",
    "description": "Choose Navi Mumbai to Mahabaleshwar Taxi for safe and affordable hill station travel with experienced drivers and clean AC vehicles."
  },
  {
    "name": "Navi Mumbai to Mahabaleshwar Cab Service",
    "description": "Book Navi Mumbai to Mahabaleshwar Cab Service for hassle-free one-way and round-trip travel with professional chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Taxi from Navi Mumbai to Mahabaleshwar",
    "description": "Hire Taxi from Navi Mumbai to Mahabaleshwar for convenient intercity travel with punctual pickups, spacious vehicles, and comfortable seating."
  },
  {
    "name": "Cab from Navi Mumbai to Mahabaleshwar",
    "description": "Book Cab from Navi Mumbai to Mahabaleshwar for reliable transportation with experienced drivers, transparent pricing, and premium travel comfort."
  },
  {
    "name": "Book Cab Navi Mumbai to Mahabaleshwar",
    "description": "Reserve Book Cab Navi Mumbai to Mahabaleshwar online with instant confirmation, flexible pickup timings, and multiple vehicle choices."
  },
  {
    "name": "Online Cab Booking Navi Mumbai to Mahabaleshwar",
    "description": "Choose Online Cab Booking Navi Mumbai to Mahabaleshwar for secure reservations, quick confirmation, and dependable chauffeur-driven travel."
  },
  {
    "name": "Best Cab Navi Mumbai to Mahabaleshwar",
    "description": "Book the Best Cab Navi Mumbai to Mahabaleshwar for premium travel with experienced chauffeurs, sanitized vehicles, and exceptional customer service."
  },
  {
    "name": "Cheapest Cab Navi Mumbai to Mahabaleshwar",
    "description": "Choose the Cheapest Cab Navi Mumbai to Mahabaleshwar with budget-friendly pricing, comfortable AC vehicles, and reliable transportation services."
  },
  {
    "name": "Reliable Taxi Navi Mumbai to Mahabaleshwar",
    "description": "Reserve Reliable Taxi Navi Mumbai to Mahabaleshwar for dependable travel with verified drivers, clean vehicles, and timely pickup services."
  },
  {
    "name": "One Way Cab Navi Mumbai to Mahabaleshwar",
    "description": "Book One Way Cab Navi Mumbai to Mahabaleshwar for economical drop taxi services without return charges and enjoy comfortable intercity travel."
  },
  {
    "name": "Round Trip Cab Navi Mumbai to Mahabaleshwar",
    "description": "Choose Round Trip Cab Navi Mumbai to Mahabaleshwar for sightseeing tours, family holidays, and return travel with flexible schedules."
  },
  {
    "name": "Outstation Cab Navi Mumbai to Mahabaleshwar",
    "description": "Book Outstation Cab Navi Mumbai to Mahabaleshwar for long-distance travel with premium vehicles, experienced chauffeurs, and affordable fares."
  },
  {
    "name": "Innova Cab Navi Mumbai to Mahabaleshwar",
    "description": "Reserve Innova Cab Navi Mumbai to Mahabaleshwar for spacious family travel with comfortable seating, extra luggage space, and smooth hill station journeys."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai to Mahabaleshwar",
    "description": "Choose Innova Crysta Cab Navi Mumbai to Mahabaleshwar for luxury travel with premium interiors, spacious seating, and professional chauffeur service."
  },
  {
    "name": "Ertiga Cab Navi Mumbai to Mahabaleshwar",
    "description": "Book Ertiga Cab Navi Mumbai to Mahabaleshwar for affordable family trips with clean AC vehicles, experienced drivers, and comfortable seating."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai to Mahabaleshwar",
    "description": "Reserve Swift Dzire Cab Navi Mumbai to Mahabaleshwar for economical travel with clean sedan vehicles, professional chauffeurs, and reliable service."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai to Mahabaleshwar",
    "description": "Choose Kia Carens Cab Navi Mumbai to Mahabaleshwar for premium family travel with spacious interiors, comfortable seating, and smooth long-distance journeys."
  },
  {
    "name": "Sedan Cab Navi Mumbai to Mahabaleshwar",
    "description": "Book Sedan Cab Navi Mumbai to Mahabaleshwar for affordable and comfortable travel with AC sedans, experienced drivers, and transparent pricing."
  },
  {
    "name": "SUV Cab Navi Mumbai to Mahabaleshwar",
    "description": "Reserve SUV Cab Navi Mumbai to Mahabaleshwar for spacious travel with premium comfort, additional luggage capacity, and reliable chauffeur-driven service."
  }
],
"tableData": [
  ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi Fare"],
  ["Mumbai to Mahabaleshwar Taxi", "Car from Mumbai to Mahabaleshwar"],
  ["Mumbai to Mahabaleshwar Cab Booking", "Mumbai to Mahabaleshwar Round Trip Cab"],
  ["Taxi for Mahabaleshwar from Mumbai", "Navi Mumbai to Mahabaleshwar Cab"],
  ["Navi Mumbai to Mahabaleshwar Taxi", "Navi Mumbai to Mahabaleshwar Cab Service"],
  ["Taxi from Navi Mumbai to Mahabaleshwar", "Cab from Navi Mumbai to Mahabaleshwar"],
  ["Book Cab Navi Mumbai to Mahabaleshwar", "Online Cab Booking Navi Mumbai to Mahabaleshwar"],
  ["Best Cab Navi Mumbai to Mahabaleshwar", "Cheapest Cab Navi Mumbai to Mahabaleshwar"],
  ["Reliable Taxi Navi Mumbai to Mahabaleshwar", "One Way Cab Navi Mumbai to Mahabaleshwar"],
  ["Round Trip Cab Navi Mumbai to Mahabaleshwar", "Outstation Cab Navi Mumbai to Mahabaleshwar"],
  ["Innova Cab Navi Mumbai to Mahabaleshwar", "Innova Crysta Cab Navi Mumbai to Mahabaleshwar"],
  ["Ertiga Cab Navi Mumbai to Mahabaleshwar", "Swift Dzire Cab Navi Mumbai to Mahabaleshwar"],
  ["Kia Carens Cab Navi Mumbai to Mahabaleshwar", "Sedan Cab Navi Mumbai to Mahabaleshwar"],
  ["SUV Cab Navi Mumbai to Mahabaleshwar", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai to Mahabaleshwar Cab Service",
    WhyChoosedescription: "Escape the city and travel to the beautiful hill station of Mahabaleshwar with Shreesha Travels. Our Navi Mumbai to Mahabaleshwar cab service offers a comfortable, private, and hassle-free journey for families, couples, tourists, and corporate travellers."
  },
  {
    WhyChooseheading: "Private Cab for a Relaxing Hill Station Journey",
    WhyChoosedescription: "Enjoy direct door-to-door transportation from Navi Mumbai to Mahabaleshwar without changing buses or trains. Our chauffeur-driven taxis provide a peaceful travel experience through scenic Western Ghats routes."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles for Every Group",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles depending on your group size and luggage requirements."
  },
  {
    WhyChooseheading: "Perfect for Holidays, Honeymoon & Weekend Trips",
    WhyChoosedescription: "Our Navi Mumbai to Mahabaleshwar taxi service is ideal for family vacations, honeymoon tours, sightseeing holidays, weekend getaways, destination weddings, and leisure travel."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way cab to Mahabaleshwar or reserve a round-trip package with flexible return timing, sightseeing stops, and personalized travel itineraries."
  },
  {
    WhyChooseheading: "Experienced Drivers for Ghat Road Travel",
    WhyChoosedescription: "Our professional chauffeurs are experienced on expressways and mountain roads, ensuring safe driving, punctual service, and a smooth travel experience throughout the journey."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide maximum comfort and reliability during long-distance travel."
  },
  {
    WhyChooseheading: "Book Navi Mumbai to Mahabaleshwar Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking confirmation, professional chauffeur service, and dependable transportation for your Mahabaleshwar trip from Navi Mumbai."
  }
]

};

const faqData = [
  {
    question: "Can I book a one-way cab from Navi Mumbai to Mahabaleshwar?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Navi Mumbai to Mahabaleshwar."
  },
  {
    question: "Do you provide round-trip cabs for Mahabaleshwar holidays?",
    answer: "Yes, round-trip packages are available with flexible return timings and customized travel plans."
  },
  {
    question: "Which vehicles are available for Navi Mumbai to Mahabaleshwar travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I visit Panchgani during the journey?",
    answer: "Yes, customized itineraries can include Panchgani and other nearby sightseeing destinations according to your travel plan."
  },
  {
    question: "Is this cab service suitable for family vacations?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, children, and senior citizens travelling to Mahabaleshwar."
  },
  {
    question: "Do you provide cabs for honeymoon trips?",
    answer: "Yes, couples can book private chauffeur-driven cabs for comfortable and relaxing honeymoon travel."
  },
  {
    question: "Can I schedule an early morning departure?",
    answer: "Yes, pickups can be arranged according to your preferred travel time, including early morning departures."
  },
  {
    question: "How is the Navi Mumbai to Mahabaleshwar cab fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, trip duration, tolls, route, and additional travel requirements."
  },
  {
    question: "Can I add sightseeing stops during my trip?",
    answer: "Yes, sightseeing stops and customized travel routes can be included upon request."
  },
  {
    question: "How can I book Navi Mumbai to Mahabaleshwar Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, destination, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Chirag Mehta",
    feedback: "Our Mahabaleshwar trip from Navi Mumbai was fantastic. The car was comfortable, the driver was polite, and the journey through the hills was very smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Desai",
    feedback: "Excellent cab service with professional support. The vehicle was clean, spacious, and our family enjoyed a safe and relaxing journey to Mahabaleshwar.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Mahabaleshwar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-to-mahabaleshwar-cab.webp",
  "description":
    "Book Navi Mumbai to Mahabaleshwar Cab with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for weekend trips, family vacations, sightseeing tours, one-way, round-trip, and long-distance journeys from Navi Mumbai to Mahabaleshwar with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-to-mahabaleshwar-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Mahabaleshwar Cab | Outstation Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Mahabaleshwar Cab with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way trips, round trips, family vacations, sightseeing tours, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Mahabaleshwar Cab, Mumbai to Mahabaleshwar Taxi Fare, Mumbai to Mahabaleshwar Taxi, Car from Mumbai to Mahabaleshwar, Mumbai to Mahabaleshwar Cab Booking, Mumbai to Mahabaleshwar Round Trip Cab, Navi Mumbai to Mahabaleshwar Cab, Navi Mumbai to Mahabaleshwar Taxi, Mahabaleshwar Tour Cab, One Way Cab Mumbai to Mahabaleshwar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimumbaiToMahabaleshwarCab;